<div
  class="test-uc-monitoring-not-connected flex flex-1 flex-col items-center justify-center gap-7 bg-ui-gray-300 px-4 py-6 text-center text-xl leading-6 text-ui-gray-1050"
  role="status"
>
  <img
    class="h-[5.25rem] w-[8.75rem]"
    alt=""
    aria-hidden="true"
    src="assets/icons/uc-monitoring-not-connected.svg"
  />
  <p class="m-0">
    UC Monitoring isn’t available yet.
    @if (canConfigure()) {
      <a
        class="ml-1 underline underline-offset-2"
        [queryParams]="{
          tab: 'connections',
        }"
        routerLink="/settings"
      >Open Connections</a>
    }
  </p>
</div>
